import React, { Component } from "react";
import {
  Select,
  MenuItem,
  TextField,
  IconButton,
  FormControl,
  InputLabel,
} from "@mui/material";
import {
  DeleteIconNew,
  AddItemIcon,
  EditIconNew,
  CancelIcon,
} from "../../../../component/icons/icons";
import Input from "../../../../component/inputpm";
import classes from "../../component/component.module.css";
import CloseIcon from "@mui/icons-material/Close";

class CustomDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: props.defaultValue || "",
      showInput: false, // Show input field when adding a new option
      newOption: "",
      enumerationValues: [],
      actionType: props.actionType || "edit",
      formatValue: props.formatValue || "",
      isDropdownOpen: false,
      showErrorMessageText: "",
      editingIndex: null,
      characteristicsEnumValueError: false,
    };
  }

  componentDidUpdate(prevProps) {
    // If defaultValue changes, update state
    if (prevProps.defaultValue !== this.props.defaultValue) {
      this.setState({ selectedOption: this.props.defaultValue || "" });
    }
    if (prevProps.formatValue !== this.props.formatValue) {
      this.setState({ formatValue: this.props.formatValue || "" });
    }
  }

  validateFormat = (value, format) => {
    if (!format || !value || value === "-") return true;

    try {
      const regex = new RegExp(`^(${format})$`, "i");
      return regex.test(value);
    } catch (error) {
      //console.error("Invalid regex format:", format);
      return true; // Allow it if the regex is broken
    }
  };
  handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    console.log("handleSelectChange------selectedValue-----", selectedValue);
    if (selectedValue !== undefined) {
      let isValid = this.validateFormat(selectedValue, this.state.formatValue);
      if (isValid) {
        this.setState({
          selectedOption: selectedValue || "",
          editingIndex: null,
          showErrorMessage: false,
          showErrorMessageText: "",
          characteristicsEnumValueError: false,
        });
        // Call parent function to update state
        if (this.props.onSelectChange) {
          this.props.onSelectChange(selectedValue);
        }
        if (this.props.onErrorChange) {
          this.props.onErrorChange("value", false);
        }
      } else {
        console.log("else-----------");
        this.setState({ characteristicsEnumValueError: true });
        if (this.props.onErrorChange) {
          this.props.onErrorChange("value", true);
        }
      }
    }
  };

  handleAddNewOption = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ showInput: true, newOptionId: "", newOptionValue: "" });
  };

  handleInputChange = (event) => {
    this.setState({ newOption: event.target.value });
  };

  handleSaveNewOption = (event) => {
    //event.preventDefault();
    //event.stopPropagation();

    const { newOptionId, newOptionValue, enumerationValues } = this.state;
    const { options } = this.props || [];
    if (!newOptionId || !newOptionValue) {
      this.setState({
        showErrorMessage: true,
        showErrorMessageText: " ID or Value should not be empty.",
        characteristicsEnumValueError: true,
      });
      return;
    }
    // Prevent duplicate
    //const allItems = [...options, ...enumerationValues];
    const allItems = [...(options || []), ...(enumerationValues || [])];

    const isDuplicate = allItems.some((item, i) => {
      return item.id === newOptionId || item.value === newOptionValue;
    });

    if (isDuplicate) {
      this.setState({
        showErrorMessage: true,
        showErrorMessageText: "Duplicate ID or Value not allowed",
        characteristicsEnumValueError: true,
      });
      return;
    }
    // Ensure both ID and Value are provided
    if (
      newOptionId &&
      newOptionId.trim() &&
      newOptionValue &&
      newOptionValue.trim()
    ) {
      let isValid = this.validateFormat(newOptionValue, this.state.formatValue);
      if (isValid) {
        //const updatedValues = [...enumerationValues, { id: newOptionId, value: newOptionValue }];
        // Reset isDefault for existing values
        const resetValues = (enumerationValues || []).map((v) => ({
          ...v,
          isDefault: false,
        }));

        // Add the new one as default
        const updatedValues = [
          ...resetValues,
          { id: newOptionId, value: newOptionValue, isDefault: true },
        ];

        this.setState({
          selectedOption: newOptionValue,
          newOptionId: "",
          newOptionValue: "",
          enumerationValues: updatedValues,
          showInput: false,
          showErrorMessage: false,
          characteristicsEnumValueError: false,
        });

        // Send updated enumeration values to Parent
        if (this.props.onSelectChange) {
          this.props.onSelectChange(newOptionValue);
        }

        if (this.props.onEnumerationChange) {
          this.props.onEnumerationChange(updatedValues);
        }
        if (this.props.onErrorChange) {
          this.props.onErrorChange("value", false);
        }
      } else {
        this.setState({
          newOptionId: "",
          newOptionValue: "",
          showInput: false,
          //showErrorMessage:true,
          characteristicsEnumValueError: true,
        });
        if (this.props.onErrorChange) {
          this.props.onErrorChange("value", true);
        }
      }
    } else {
      alert("Both ID and Value are required!");
    }
  };

  handleSaveEditedOption = (index, originalItem) => {
    const { editingOptionId, editingOptionValue, enumerationValues } =
      this.state;
    const { options } = this.props;
    console.log(editingOptionId, editingOptionValue);
    if (!editingOptionId || !editingOptionValue) {
      /*if (this.props.onErrorChange) {
              this.props.onErrorChange("value", true);
            }*/
      this.setState({
        showErrorMessage: true,
        showErrorMessageText: " ID or Value should not be empty.",
        characteristicsEnumValueError: true,
      });
      return;
    }
    //console.log("should not empty");
    if (!originalItem) {
      console.error("Original item not found.");
      return;
    }

    const allItems = [...options, ...enumerationValues];
    console.log("============allItems================", allItems);
    console.log(
      editingOptionId,
      "============editingOptionId=====editingOptionValue===========",
      editingOptionValue,
    );
    const isDuplicate = allItems.some((item, i) => {
      return (
        i !== index &&
        (item.id === editingOptionId || item.value === editingOptionValue)
      );
    });

    if (isDuplicate) {
      //alert("Duplicate ID or Value not allowed");
      /*if (this.props.onErrorChange) {
              this.props.onErrorChange("value", true);
            }*/
      this.setState({
        showErrorMessage: true,
        showErrorMessageText: "Duplicate ID or Value not allowed.",
        characteristicsEnumValueError: true,
      });
      return;
    }

    let isValid = this.validateFormat(
      editingOptionValue,
      this.state.formatValue,
    );
    if (isValid) {
      const updatedItem = { id: editingOptionId, value: editingOptionValue };

      const existingIndexInOptions = options.findIndex(
        (opt) => opt.id === originalItem.id && opt.value === originalItem.value,
      );

      if (existingIndexInOptions !== -1) {
        options[existingIndexInOptions] = updatedItem;
      } else {
        const existingIndexInNew = enumerationValues.findIndex(
          (opt) =>
            opt.id === originalItem.id && opt.value === originalItem.value,
        );
        if (existingIndexInNew !== -1) {
          enumerationValues[existingIndexInNew] = updatedItem;
        }
      }

      this.setState(
        {
          enumerationValues: [...enumerationValues],
          editingIndex: null,
          editingOptionId: "",
          editingOptionValue: "",
          characteristicsEnumValueError: false,
        },
        () => {
          const updatedValues = [...options];
          if (this.props.onEnumerationChange) {
            this.props.onEnumerationChange(updatedValues);
          }
        },
      );
      if (this.props.onSelectChange) {
        this.props.onSelectChange(editingOptionValue);
      }

      if (this.props.onErrorChange) {
        this.props.onErrorChange("value", false);
      }
    } else {
      this.setState({
        //editingOptionId: "",
        //editingOptionValue: "",
        characteristicsEnumValueError: true,
      });
      if (this.props.onErrorChange) {
        this.props.onErrorChange("value", true);
      }
    }
  };

  handleEditOption = (e, index, item) => {
    e.stopPropagation();
    this.setState({
      editingIndex: index,
      editingOptionId: item.id,
      editingOptionValue: item.value,
    });
  };

  handleRemoveOption = (e, itemToRemove) => {
    e.stopPropagation(); // prevent dropdown from closing
    const { enumerationValues } = this.state;
    const { options, onDeleteEnumerationValue, onEnumerationChange } =
      this.props;

    const isInOptions = options.some(
      (item) =>
        item.id === itemToRemove.id && item.value === itemToRemove.value,
    );

    // If it's in props.options, notify parent to remove it
    if (isInOptions) {
      const updatedOptions = options.filter(
        (item) =>
          !(item.id === itemToRemove.id && item.value === itemToRemove.value),
      );
      if (onDeleteEnumerationValue) {
        onDeleteEnumerationValue(updatedOptions);
      }
      this.setState({ enumerationValues: updatedOptions }, () => {
        if (onEnumerationChange) {
          onEnumerationChange(updatedOptions);
        }
      });
    } else {
      // Else it's a local value (created just now)
      const updatedEnumerationValues = enumerationValues.filter(
        (item) =>
          !(item.id === itemToRemove.id && item.value === itemToRemove.value),
      );
      this.setState({ enumerationValues: updatedEnumerationValues }, () => {
        if (onEnumerationChange) {
          onEnumerationChange([...updatedEnumerationValues, ...options]); // send full list
        }
      });
    }
  };

  render() {
    const { options = [] } = this.props;
    const { selectedOption } = this.state;
    // console.log(selectedOption,"-ssssssssssssssssss--options-------",options);
    // const allOptions = [...options, ...(this.state.enumerationValues || [])];
    const isValidValue = options.some(
      (option) => option.value === selectedOption,
    );
    const displayValue = isValidValue
      ? selectedOption
      : this.state.actionType === "view"
        ? "Default Value"
        : "";
    return (
      <>
        <FormControl
          variant="outlined"
          size="small"
          className={classes.customeSelectLabel}
          fullWidth
          error={this.state.characteristicsEnumValueError}
        >
          <InputLabel id="enumValueLabel" style={{ background: "#fff" }}>
            Default Value{" "}
          </InputLabel>
          <Select
            labelId="enumValueLabel"
            value={displayValue}
            onChange={this.handleSelectChange}
            displayEmpty
            style={{ width: "100%" }}
            open={this.state.showInput ? true : undefined}
            MenuProps={{ disableAutoFocusItem: true }}
            size="small"
            variant="outlined"
            disabled={this.state.actionType === "view"}
            className="customEnumBoxSize"
            onOpen={() => this.setState({ isDropdownOpen: true })}
            onClose={() => this.setState({ isDropdownOpen: false })}
          >
            {/* Default Option */}
            <MenuItem key="default" value="-" disabled>
              Select an Option
            </MenuItem>

            {[
              ...new Set(
                [...options, ...this.state.enumerationValues].map(
                  JSON.stringify,
                ),
              ),
            ].map((strItem, index) => {
              const item = JSON.parse(strItem);

              const isEditing = this.state.editingIndex === index;

              return isEditing ? (
                <MenuItem
                  key={`edit-${index}`}
                  disableRipple
                  onKeyDown={(e) => e.stopPropagation()}
                >
                  <TextField
                    autoFocus
                    placeholder="Edit ID"
                    value={this.state.editingOptionId || ""}
                    onChange={(e) =>
                      this.setState({ editingOptionId: e.target.value })
                    }
                    size="small"
                    onClick={(e) => e.stopPropagation()}
                    style={{ marginRight: "10px", width: "30%" }}
                  />
                  <TextField
                    placeholder="Edit Value"
                    value={this.state.editingOptionValue || ""}
                    onChange={(e) =>
                      this.setState({ editingOptionValue: e.target.value })
                    }
                    size="small"
                    onClick={(e) => e.stopPropagation()}
                    style={{ width: "50%" }}
                  />
                  <IconButton
                    onClick={(e) => this.handleSaveEditedOption(index, item)}
                    style={{ marginLeft: "auto" }}
                  >
                    <AddItemIcon />
                  </IconButton>
                  <IconButton
                    onClick={() =>
                      this.setState({
                        editingIndex: null,
                        showErrorMessage: false,
                        showErrorMessageText: "",
                      })
                    }
                    size="small"
                    className="customEnumBoxCancelBtn"
                    style={{ marginLeft: "5px", padding: "4px" }}
                  >
                    <CloseIcon />
                  </IconButton>
                </MenuItem>
              ) : (
                <MenuItem key={`enum-${item.id}-${index}`} value={item.value}>
                  {item.id} : {item.value}
                  {this.state.isDropdownOpen && (
                    <>
                      <IconButton
                        size="small"
                        onClick={(e) => this.handleEditOption(e, index, item)}
                        style={{ marginLeft: "auto" }}
                      >
                        <EditIconNew />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={(e) => this.handleRemoveOption(e, item)}
                        style={{ marginLeft: "5px" }}
                      >
                        <DeleteIconNew fontSize="small" />
                      </IconButton>
                    </>
                  )}
                </MenuItem>
              );
            })}

            {/* Input Field for New Option */}
            {this.state.showInput ? (
              <MenuItem
                key="input-field"
                disableRipple
                onKeyDown={(e) => e.stopPropagation()}
                style={{ paddingLeft: "10px" }}
              >
                <TextField
                  autoFocus
                  placeholder="Enter ID"
                  value={this.state.newOptionId || ""}
                  onChange={(e) =>
                    this.setState({ newOptionId: e.target.value })
                  }
                  size="small"
                  onClick={(e) => e.stopPropagation()}
                  onKeyDown={(e) =>
                    e.key === "Enter" && this.handleSaveNewOption(e)
                  }
                  style={{ marginRight: "10px", width: "30%" }}
                />
                <TextField
                  placeholder="Enter Value"
                  value={this.state.newOptionValue || ""}
                  onChange={(e) =>
                    this.setState({ newOptionValue: e.target.value })
                  }
                  size="small"
                  onClick={(e) => e.stopPropagation()}
                  onKeyDown={(e) =>
                    e.key === "Enter" && this.handleSaveNewOption(e)
                  }
                  style={{ width: "70%" }}
                />
                <IconButton
                  size="small"
                  onClick={(e) => this.handleSaveNewOption(e)}
                  onKeyDown={(e) => e.preventDefault()}
                >
                  <AddItemIcon />
                </IconButton>
              </MenuItem>
            ) : (
              <MenuItem
                key="add-new"
                onKeyDown={(e) => e.stopPropagation()}
                style={{ paddingLeft: "5px" }}
              >
                <IconButton
                  size="small"
                  onClick={this.handleAddNewOption}
                  onKeyDown={(e) => e.preventDefault()}
                >
                  <AddItemIcon />{" "}
                  <span className="text-ui" style={{ paddingLeft: "5px" }}>
                    Create New
                  </span>
                </IconButton>
              </MenuItem>
            )}
          </Select>
        </FormControl>
        {this.state.showErrorMessage && (
          <p className="text-error" style={{ marginTop: "4px" }}>
            {this.state.showErrorMessageText}
          </p>
        )}
      </>
    );
  }
}

export default CustomDropdown;
